import request from '@/utils/request'

/**
 * 用户登录
 * @param {Object} data - { username, password }
 * @returns {Promise}
 */
export function login(data) {
    return request({
        url: '/weblogin',
        method: 'post',
        data
    })
}

/**
 * 用户注册
 * @param {Object} data - { contactName, username, password, deptId, yzcode }
 * @returns {Promise}
 */
export function register(data) {
    return request({
        url: '/register',
        method: 'post',
        data
    })
}

/**
 * 发送验证码
 * @param {string} phone - 手机号
 * @returns {Promise}
 */
export function sendCode(phone) {
    // 使用 form-data 格式（不要手动设置 Content-Type，让浏览器自动添加 boundary）
    const formData = new FormData()
    formData.append('phone', phone)
    return request({
        url: '/sendcode',
        method: 'post',
        data: formData,
        timeout: 30000
    })
}

/**
 * 获取用户信息
 * @returns {Promise}
 */
export function getUserInfo() {
    return request({
        url: '/getInfo',
        method: 'get'
    })
}

/**
 * 退出登录
 * @returns {Promise}
 */
export function logout() {
    return request({
        url: '/logout',
        method: 'post'
    })
}

/**
 * 获取微信用户信息
 * @returns {Promise}
 */
export function getWxUserInfo() {
    return request({
        url: '/wx/user/getUserInfo',
        method: 'post'
    })
}
/**
 * 重置密码
 * @param {Object} data - { newPassword, code }
 * @returns {Promise}
 */
export function resetPassword(data) {
    return request({
        url: '/resetPassword',
        method: 'post',
        data
    })
}

/**
 * 同步ERP客户信息
 */
export function syncCustomerInfo() {
    return request({
        url: '/shop/user/api/auditCustomerStatus',
        method: 'post'
    })
}

/**
 * 更新微信用户信息 (如头像)
 * @param {Object} data - { avatar, ... }
 */
export function updateWxUserInfo(data) {
    return request({
        url: '/wxuser/updateUser/api',
        method: 'post',
        data
    })
}

/**
 * 修改资料
 * @param {Object} data - { contactName, email, phonenumber, yzcode }
 */
export function updateProfile(data) {
    return request({
        url: '/shop/customer/api/updateProfile',
        method: 'post',
        data
    })
}

/**
 * 注销账户
 */
export function deregister() {
    return request({
        url: '/shop/customer/api/deregister',
        method: 'post'
    })
}
/**
 * 获取信息列表 (如用户协议)
 * @param {Object} params - { position, ... }
 * @returns {Promise}
 */
export function getInfoList(params) {
    return request({
        url: '/info/info/api/list',
        method: 'get',
        params
    })
}
/**
 * 申请或续期月结
 * @param {Object} data - { phonenumber, applyType }
 */
export function applyMonthlySettlement(data) {
    return request({
        url: '/shop/customer/api/applyMonthlySettlement',
        method: 'post',
        data
    })
}
